import React, { useState } from 'react'
import {
  Paper,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material'
import {
  MoreVert as MoreVertIcon,
  Clear as ClearIcon,
  Block as BlockIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material'

interface BulkActionsToolbarProps {
  selectedCount: number
  onBulkInvertedUpdate: (inverted: boolean) => void
  onBulkDelete: () => void
  onClearSelection: () => void
}

export function BulkActionsToolbar({
  selectedCount,
  onBulkInvertedUpdate,
  onBulkDelete,
  onClearSelection,
}: BulkActionsToolbarProps) {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null)

  return (
    <Paper sx={{ mb: 2 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flex: '1 1 100%' }}>
          {selectedCount} evrak seçildi
        </Typography>
        <Tooltip title="Toplu İşlemler">
          <IconButton onClick={(e) => setMenuAnchor(e.currentTarget)}>
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => setMenuAnchor(null)}
        >
          <MenuItem
            onClick={() => {
              onBulkInvertedUpdate(true)
              setMenuAnchor(null)
            }}
          >
            <ListItemIcon>
              <BlockIcon />
            </ListItemIcon>
            <ListItemText primary="Tümünü Yasakla" />
          </MenuItem>
          <MenuItem
            onClick={() => {
              onBulkInvertedUpdate(false)
              setMenuAnchor(null)
            }}
          >
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Yasakları Kaldır" />
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              onBulkDelete()
              setMenuAnchor(null)
            }}
            sx={{ color: 'error.main' }}
          >
            <ListItemIcon>
              <DeleteIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="Seçilenleri Sil" />
          </MenuItem>
        </Menu>
        <Tooltip title="Seçimi Temizle">
          <IconButton onClick={onClearSelection}>
            <ClearIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </Paper>
  )
}
